<template>
  <div>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-dialog v-model="tanitimDialog" width="500">
      <v-card>
        <v-card-title class="headline white--text lighten-2" style="background-color: #01579b" primary-title>
          {{ $t("Information-Request") }}
        </v-card-title>

        <v-card-text>
          <v-alert :value="true" v-show="HrRez" color="warning" icon="priority_high" outline>
            {{ $t("HR") }}
          </v-alert>

          <v-form ref="formmesaj" v-model="validmesaj" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12 md12 sm12>
                <v-text-field :rules="[(v) => !!v || $t('Mandatory-Areas')]" v-model="mailDialog.SirketAdi"
                  :label="$t('Company-Name')">
                </v-text-field>
              </v-flex>
              <v-flex xs12 md12 sm12>
                <v-text-field v-model="mailDialog.Adres" :label="$t('Address_label')">
                </v-text-field>
              </v-flex>
              <v-flex xs12 md12 sm12>
                <v-text-field :rules="[(v) => !!v || $t('Mandatory-Areas')]" v-model="mailDialog.AdSoyad"
                  :label="$t('Name_Surname_label')">
                </v-text-field>
              </v-flex>
              <v-flex xs12 md12 sm12>
                <v-text-field :rules="[(v) => !!v || $t('Mandatory-Areas')]" v-model="mailDialog.Email"
                  :label="$t('Email_label')">
                </v-text-field>
              </v-flex>
              <v-flex xs12 md12 sm12>
                <v-text-field :rules="[(v) => !!v || $t('Mandatory-Areas')]" v-model="mailDialog.GSM"
                  :label="$t('Telephone')">
                </v-text-field>
              </v-flex>
              <v-flex xs12 md12 sm12>
                <v-textarea rows="10" :rules="[(v) => !!v || $t('Mandatory-Areas')]" v-model="mailDialog.Mesaj"
                  :label="$t('Message')">
                </v-textarea>
              </v-flex>
              <v-flex xs12 md12 sm12>
                <v-subheader>{{ $t("Information-Requested-Providers") }}</v-subheader>
                <v-checkbox v-for="item in providers" v-model="selectedProviders" :label="`${item.Provider}`"
                  :value="item.Provider" dense class="my-0"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click=" epostagonder(
            'talep@arkman.com.tr',
            'ARKMAN -  MARKETPLACE BİLGİ TALEBİ')">
            {{ $t("OK") }}
          </v-btn>
          <v-btn color="error" flat @click="tanitimDialog = false">
            {{ $t("Cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import axios from "axios";
import auth from "@/api/auth.js";
import { VSubheader } from "vuetify/lib";

export default {
  props: {
    servisTipi: {
      type: Number, //1:Runner 2:PaxDrive
    },
    providers: {
      type: Array
    }
  },
  data() {
    return {
      HrRez: false,
      mailDialog: {
        AdSoyad: null,
        Email: null,
        SirketAdi: null,
        GSM: null,
        Adres: null,
        Mesaj: null,
      },
      text1: null,
      snackbar: false,
      validmesaj: true,
      tanitimDialog: false,
      selectedProviders: []
    };
  },
  components: {
    snackbarcomp,
    axios,
  },
  methods: {
    open(val) {

      if (val == 1) { //HR rez sirasindaki uyariyi goster
        this.HrRez = true;
      } else {
        this.HrRez = false;
      }
      var WebUser = JSON.parse(
        window.localStorage.getItem("WebUserManageLoad")
      );
      var WebCompany = JSON.parse(window.localStorage.getItem("credentials"));

      var currentCompanyId = WebCompany.SirketKodu;
      var adRes = WebCompany.CoperSirketler.map(function (sirketler) {
        if (sirketler.SirketNo == currentCompanyId) {
          return sirketler.SirketAdres1 + " " + sirketler.SirketAdres2;
        }
      });

      this.mailDialog.Adres = adRes;
      this.mailDialog.AdSoyad = WebUser.UserInfo.AdSoyad;
      this.mailDialog.Email = WebUser.UserInfo.Email;
      this.mailDialog.SirketAdi = WebCompany.SirketUnvani;
      this.mailDialog.GSM = WebUser.UserInfo.GSM;
      this.tanitimDialog = true;
    },
    agree() {
      if (this.$refs.formmesaj.validate()) {
        switch (this.servisTipi) {
          case 1: // HotelRunner için Demo Talebi oluşturuluyor
            this.epostagonder(
              "talep@arkman.com.tr",
              "ARKMAN - HOTELRUNNER SİSTEM BİLGİ TALEBİ"
            );
            break;
          case 2:
            this.epostagonder(
              "talep@arkman.com.tr",
              "ARKMAN - PAXDRIVE SİSTEM BİLGİ TALEBİ"
            );
            break;
          case 3:
            this.epostagonder(
              "talep@arkman.com.tr",
              "ARKMAN -  SİSTEM BİLGİ TALEBİ"
            );
            break;
          default:
            break;
        }

      }
    },
    cancel() {
      this.tanitimDialog = false;
    },
    epostagonder(mail, title) {
      let formData = new FormData();
      formData.append("Konu", title);
      formData.append("to", mail);
      formData.append("mailType", "0");
      var okMail = `Acente Adı = ${this.mailDialog.SirketAdi} | Ad Soyad = ${this.mailDialog.AdSoyad} 
      | Telefon = ${this.mailDialog.GSM} | E-Mail = ${this.mailDialog.Email} | Adres = ${this.mailDialog.Adres} 
      | Bilgi İstenilen Providerlar = ${this.selectedProviders} \n Mesaj = ${this.mailDialog.Mesaj}`
      formData.append("formattedMessage", okMail);

      axios.defaults.baseURL = auth.API_URL;
      axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
      axios
        .post(auth.API_URL + "api/Helpers/SendEmail", formData, {
          headers: {},
        })
        .then((response) => {
          if (response.data == true) {
            this.snackbar = true;
            this.text1 = "Sistem Bilgi Talebi Oluşturuldu";
            this.tanitimDialog = false;
            // this.text1 =
            //   "Sistemde kayıtlı mail adresinize onay maili gönderilmiştir. Mailinizi onaylayarak giriş yapabilirsiniz."
            // this.snackbar = true
          } else {
            this.snackbar = true;
            this.text1 = "Sistem Bilgi Talebi Oluşturulamadı";
            // this.text1 = this.$t('Your-user-record-has-been-created-approval-mail-has-not-been-sent-your-mail')
            // this.snackbar = true
          }
        })
        .catch(function () { });
    },
  },
};
</script>
